/** Column sort shared by the queue tables (AI Reports, Quotes, Work Orders, Invoices).
 *  A sort is `{ key, dir }` with dir 'asc' | 'desc', or null for the page's default order
 *  (newest first). The backend whitelists the keys; see QwiListSort / ScrubEstimateSpecification. */

/** Header click cycle: a new column starts ascending, then descending, then back to the default. */
export const nextSort = (current, key) => {
  if (!current || current.key !== key) return { key, dir: 'asc' }
  if (current.dir === 'asc') return { key, dir: 'desc' }
  return null
}

/** Reads `?sort=<key>&dir=asc|desc` (only keys the page offers). */
export const sortFromQuery = (queryParams, allowedKeys) => {
  const key = queryParams.get('sort')
  if (!key || (allowedKeys && !allowedKeys.includes(key))) return null
  return { key, dir: queryParams.get('dir') === 'asc' ? 'asc' : 'desc' }
}

/** Writes the sort into URLSearchParams (nothing for the default order). */
export const writeSortToQuery = (params, sort) => {
  if (!sort) return
  params.set('sort', sort.key)
  params.set('dir', sort.dir)
}

/** The `sortBy` / `sort` request params the list APIs take. */
export const sortRequestParams = (sort) => (sort ? { sortBy: sort.key, sort: sort.dir.toUpperCase() } : {})
